import React from 'react';

import Loader from 'components/Loader/Loader';
import ReportsSitrepCard from 'components/Reports/ReportsSitrepCard';
import {
  SitrepCardSurface,
  type SitrepViewDataProps,
} from 'components/Reports/reports.types';

type ReviewReportViewProps = {
  pendingReviews: SitrepViewDataProps;
};

const ReviewReportView: React.FC<ReviewReportViewProps> = ({
  pendingReviews,
}) => {
  return (
    <div className="reports-tabs">
      {pendingReviews.isError ? (
        <div className="text-center mt-4">
          <span>Error loading reports.</span>
        </div>
      ) : pendingReviews.isLoading ? (
        <Loader />
      ) : pendingReviews.data.length > 0 ? (
        pendingReviews.data.map((sitrep) => (
          <ReportsSitrepCard
            key={sitrep.id}
            sitrep={sitrep}
            surface={SitrepCardSurface.Review}
          />
        ))
      ) : (
        <div className="reports-tabs__header__empty">
          <p>No SITREPs pending review</p>
        </div>
      )}
    </div>
  );
};

export default ReviewReportView;
